/**
 * @file Undoes a charge's direct-to-owner route through the charge-keyed `charges/:chargeId/undoPaidToOwner`.
 * A refusal the undo route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  financial_operations_were_blocked: { titleKey: "refusal-title-undo-paid-to-owner", bodyKey: "refusal-body-financial-processing-busy" },
  be_charge_not_found: { titleKey: "refusal-title-undo-paid-to-owner", bodyKey: "refusal-body-charge-not-found" },
  undo_paid_to_owner_requires_direct_charge: { titleKey: "refusal-title-undo-paid-to-owner", bodyKey: "refusal-body-undo-not-direct" },
  cannot_unlink_payment_because_financial_statement_locked: { titleKey: "refusal-title-undo-paid-to-owner", bodyKey: "refusal-body-undo-statement-locked" }
};

export default function* undoChargePaidToOwner(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_REQUEST
    });

    yield call(Http.post, `charges/${action.payload?.charge?.id}/undoPaidToOwner`);

    yield put({
      type: Constants.GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUndoChargePaidToOwner() {
  yield takeEvery(Constants.GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_START, undoChargePaidToOwner);
}
